var map = {
	"./arbor.png": 4944,
	"./axe.png": 5839,
	"./backpack.png": 4935,
	"./boots.png": 4659,
	"./burner.png": 1894,
	"./carbine.png": 5534,
	"./cats.png": 773,
	"./clip.png": 7515,
	"./clothes.png": 7467,
	"./first-aid-kit.png": 1173,
	"./folding-chair.png": 1169,
	"./helmets.png": 35,
	"./hooks.png": 8875,
	"./iceAxe.png": 8079,
	"./iceDrill.png": 7043,
	"./loops.png": 4584,
	"./pot.png": 4060,
	"./radio.png": 5395,
	"./ropes.png": 5353,
	"./sleepingBag.png": 5937,
	"./strapping.png": 1439,
	"./tent.png": 751,
	"./trench.png": 1433,
	"./trigger.png": 6286,
	"./zhumary.png": 1963,
	"assets/png/item-categories/arbor.png": 4944,
	"assets/png/item-categories/axe.png": 5839,
	"assets/png/item-categories/backpack.png": 4935,
	"assets/png/item-categories/boots.png": 4659,
	"assets/png/item-categories/burner.png": 1894,
	"assets/png/item-categories/carbine.png": 5534,
	"assets/png/item-categories/cats.png": 773,
	"assets/png/item-categories/clip.png": 7515,
	"assets/png/item-categories/clothes.png": 7467,
	"assets/png/item-categories/first-aid-kit.png": 1173,
	"assets/png/item-categories/folding-chair.png": 1169,
	"assets/png/item-categories/helmets.png": 35,
	"assets/png/item-categories/hooks.png": 8875,
	"assets/png/item-categories/iceAxe.png": 8079,
	"assets/png/item-categories/iceDrill.png": 7043,
	"assets/png/item-categories/loops.png": 4584,
	"assets/png/item-categories/pot.png": 4060,
	"assets/png/item-categories/radio.png": 5395,
	"assets/png/item-categories/ropes.png": 5353,
	"assets/png/item-categories/sleepingBag.png": 5937,
	"assets/png/item-categories/strapping.png": 1439,
	"assets/png/item-categories/tent.png": 751,
	"assets/png/item-categories/trench.png": 1433,
	"assets/png/item-categories/trigger.png": 6286,
	"assets/png/item-categories/zhumary.png": 1963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7785;